import { useQuery } from '@tanstack/react-query';
import sensecapService, { SenseCapSamplesFilters } from '../api/sensecapService';
import type { SenseCapDevice, SenseCapSamplesResponse } from '../types/types';

export const useSenseCapDevices = () => {
    return useQuery<SenseCapDevice[]>({
        queryKey: ['sensecapDevices'],
        queryFn: () => sensecapService.getDevices(),
        refetchOnWindowFocus: false,
    });
};

export const useSenseCapSamples = (
    devEui: string | undefined,
    filters?: SenseCapSamplesFilters,
) => {
    return useQuery<SenseCapSamplesResponse>({
        queryKey: ['sensecapSamples', devEui, filters],
        queryFn: () => sensecapService.getSamples(devEui!, filters),
        enabled: !!devEui,
        refetchOnWindowFocus: false,
    });
};
